<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            default="today"
            type="year"
            label="년도"
            name="year"
            v-model="searchParam.year"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="search"
            stepperGrpCd="SOP_FIRE_FIGHTING_ISSUE_STEP_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="sopFireFightingIssueStepCd"
            label="진행상태"
            v-model="searchParam.sopFireFightingIssueStepCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept 
            :isFirstValue="false"
            type="search" 
            label="점검부서" 
            name="deptCd" 
            v-model="searchParam.deptCd" />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="소방 이슈점검 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable" label="등록" icon="add" @btnClicked="openPop" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'fireFightingIssueCheck',
  data() {
    return {
      searchParam: {
        plantCd: null,
        year: '',
        sopFireFightingIssueStepCd: null,
        deptCd: null,
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'issueCheckName',
            field: 'issueCheckName',
            label: '점검명',
            align: 'left',
            sortable: true,
            style: 'width: 350px',
            type: 'link',
          },
          {
            name: 'yearmonth',
            field: 'yearmonth',
            label: '점검년월',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '점검부서',
            align: 'center',
            sortable: true,
            style: 'width: 150px',
          },
          {
            name: 'sopFireFightingIssueStepName',
            field: 'sopFireFightingIssueStepName',
            label: '진행상태',
            align: 'center',
            sortable: true,
            style: 'width: 150px',
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.fft.fireFightingIssueCheck.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    openPop() {
      this.linkClick();
    },
    linkClick(row) {
      this.popupOptions.title = '소방 이슈점검 상세';
      this.popupOptions.param = {
        sopFireFightingIssueCheckId: row ? row.sopFireFightingIssueCheckId : '',
      };
      this.popupOptions.target = () => import(`${'./fireFightingIssueCheckDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
